'use es6';

import { combineReducers } from 'redux';
import Canva from 'FileManagerCore/reducers/Canva';
import Notifications from 'ReduxMessenger/reducers/Notifications';
import Auth from 'FileManagerCore/reducers/Auth';
import EditAndCreateImage from 'FileManagerCore/reducers/EditAndCreateImage';
import Files from 'FileManagerCore/reducers/Files';
import FileDetails from 'FileManagerCore/reducers/FileDetails';
import Folders from 'FileManagerCore/reducers/Folders';
import UploadingFiles from 'FileManagerCore/reducers/UploadingFiles';
import portalMeta from 'FileManagerCore/reducers/PortalMeta';
import Limits from 'FileManagerCore/reducers/Limits';
import Selection from './Selection';
import getShutterstockReducer from 'FileManagerCore/reducers/Shutterstock';
import Domains from './Domains';
import FileUsage from './FileUsage';
import VideoThumbnails from 'FileManagerCore/reducers/VideoThumbnails';
import HubUsers from 'FileManagerCore/reducers/HubUsers';
import suspension from 'FileManagerCore/reducers/Suspension';
import partitioning from 'FileManagerCore/reducers/Partitioning';
import teams from 'FileManagerCore/reducers/Teams';
import video2OptInStatus from 'FileManagerCore/reducers/Video2OptInStatus';
import modalDisplay from './ModalDisplay';
import pageSize from './PageSize';
import fileHistory from './FileHistory';
import videoSubtitles from 'FileManagerCore/reducers/videoSubtitles';
import fileExpiration from './fileExpiration';
import FilesAndFoldersTable from './FilesAndFoldersTable';
export default combineReducers({
  auth: Auth,
  domains: Domains,
  canva: Canva,
  editAndCreateImage: EditAndCreateImage,
  files: Files,
  fileDetails: FileDetails,
  folders: Folders,
  notifications: Notifications,
  selection: Selection,
  shutterstock: getShutterstockReducer({}),
  uploadingFiles: UploadingFiles,
  portalMeta,
  fileUsage: FileUsage,
  videoThumbnail: VideoThumbnails,
  limits: Limits,
  hubUsers: HubUsers,
  suspension,
  modalDisplay,
  partitioning,
  teams,
  pageSize,
  video2OptInStatus,
  videoSubtitles,
  fileHistory,
  fileExpiration,
  filesAndFoldersTable: FilesAndFoldersTable
});